import React from "react";
import { useNavigate } from "react-router-dom";
import { LayoutSituation, ResumeCard } from "../../components";
import { ContainerResumeCard } from "./styled-components";
import { useParams } from "react-router-dom";
import NegativeResponse from "./components/negative";
import PositiveResponse from "./components/positive";
import AlertePositiveResponse from "./components/alerte/postive";
import AlerteNegativeResponse from "./components/alerte/negative";
import getOrientation from "../../helper/orientations";
import { head, filter } from "lodash";

const Orientation = ({ data, steps }: { data: Domain[]; steps: Step[] }) => {
  const params = useParams();
  const navigate = useNavigate();

  const { domainData, description, orientation, contacts } = getOrientation(
    data,
    params
  );

  const getAlerttheme = () => {
    if (domainData?.domain === "alerte" && params.id) {
      const data = filter(
        head(
          filter(
            head(domainData?.situations)?.thematique,
            (thematique) => thematique.value === params.thematique
          )
        )?.themes,
        ({ id }) => id === Number(params.id)
      );

      return data;
    }
  };

  const alertTheme = head(getAlerttheme());

  const renderAlerteOrientation = () => {
    if (orientation) {
      return <AlertePositiveResponse />;
    } else {
      if (
        (params.thematique === "education" && params.id === "2") ||
        params.thematique === "public" ||
        params.thematique === "discrimination"
      ) {
        return <AlertePositiveResponse />;
      } else {
        return <AlerteNegativeResponse data={alertTheme} />;
      }
    }
  };

  const renderSituations = () => {
    switch (orientation as any) {
      case false:
        return <NegativeResponse contacts={contacts} />;
      default:
        return <PositiveResponse />;
    }
  };

  return (
    <LayoutSituation
      steps={steps}
      activeStep={params.domain === "alerte" ? 4 : 3}
      withUrgencyNumber
      onPrevious={() => {
        if (params.domain === "alerte" && !!params.thematique) {
          navigate(`/alerte/${params.theme}`, {
            replace: true,
            state: { thematique: params.thematique },
          });
        } else {
          navigate(-1);
        }
      }}
    >
      <>
        <ContainerResumeCard>
          <ResumeCard
            title={
              params.domain === "alerte" ? params.theme : domainData?.step.title
            }
            description={
              params.domain === "alerte"
                ? orientation
                  ? description
                  : alertTheme?.value
                : description
            }
          />
        </ContainerResumeCard>
        {params.domain === "alerte"
          ? renderAlerteOrientation()
          : renderSituations()}
      </>
    </LayoutSituation>
  );
};

export default Orientation;
